import { API_URL_INTEGRACAO_VOALA } from 'constants/constants';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import './RdStation.css';

function searchToObject(search) {
  return search.substring(1).split("&").reduce(function(result, value) {
    var parts = value.split('=');
    if (parts[0]) result[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
    return result;
  }, {})
}

export default function RdStationCallback() {
  const [loading, setLoading] = useState(false);
  let location = useLocation();

  useEffect(() => {
    var params = searchToObject(location.search)
    if (params.code) {
      handleCallback(params.code);
    }
  }, [location]);

  const handleCallback = (code) => {
    if (!code) return;
    setLoading(true);
    fetch(`${API_URL_INTEGRACAO_VOALA}/Conversao/Callback`, {
      method: 'POST',
      headers: {"Content-type": "application/json;charset=UTF-8"},
      body: JSON.stringify({
        Code: code,
      }),
    })
      .then(value => value.json())
      .then(json => {
        console.log(json);
        if (json.Data.AutenticarRdStation && json.Data.UrlAutenticarRdStation) {
          window.location.href = json.Data.UrlAutenticarRdStation;
        } else {
          window.location.href = json.Data.UrlVoala;
        }
        setLoading(false);
      })
      .catch(e => {
        alert('Aconteceu algum erro!');
        setLoading(false);
      });
  };

  return <>{loading && <div>Loading..</div>}</>;
}
